/**
 * 주어진 타임스탬프가 현재 시간보다 과거인지 판단하는 함수.
 * @param timestamp - 비교할 타임스탬프 (밀리초 단위).
 * @returns 타임스탬프가 현재보다 과거면 true, 그렇지 않으면 false.
 */
function isTimestampPast(timestamp: number): boolean {
  if (typeof timestamp !== 'number') return true;
  const now = Date.now();
  return timestamp < now;
}

export default isTimestampPast;
